import clsx from 'clsx';
import type { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: boolean;
}

export default function Card({ children, className, padding = true }: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-xl border border-gray-200 bg-white shadow-sm',
        padding && 'p-6',
        className,
      )}
    >
      {children}
    </div>
  );
}

interface StatCardProps {
  title: string;
  value: number | string;
  icon?: ReactNode;
  color?: 'primary' | 'danger' | 'amber' | 'green';
  subtitle?: string;
}

const colorMap: Record<string, string> = {
  primary: 'bg-primary-50 text-primary-600',
  danger: 'bg-red-50 text-red-600',
  amber: 'bg-amber-50 text-amber-600',
  green: 'bg-green-50 text-green-600',
};

export function StatCard({
  title,
  value,
  icon,
  color = 'primary',
  subtitle,
}: StatCardProps) {
  return (
    <Card>
      <div className="flex items-center gap-4">
        {icon && (
          <div className={clsx('rounded-lg p-3', colorMap[color])}>{icon}</div>
        )}
        <div>
          <p className="text-sm text-gray-500">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {subtitle && <p className="text-xs text-gray-600 mt-0.5">{subtitle}</p>}
        </div>
      </div>
    </Card>
  );
}
